import script from "./HouseSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./HouseSelection.vue?vue&type=script&setup=true&lang=js"

import "./HouseSelection.vue?vue&type=style&index=0&id=35ebe93e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35ebe93e"]])

export default __exports__